import { Navigate } from "react-router-dom"
import { intersection } from "lodash"
import { useAuthUser } from "../hooks/useAuth"
import { isFullScope, isTwoFaScope } from "../constants"
import routePaths from "../constants/path"
import FullPageLoader from "./FullPageLoader"
import Forbidden from "./Forbidden"

const ProtectedRoute = ({ component, whoCanAccess }) => {
  const { data, isLoading, isError } = useAuthUser()

  if (isLoading) return <FullPageLoader />
  if (isError || !data) return <Navigate replace to={routePaths.login} />

  if (isTwoFaScope(data.scope)) {
    return data.twoFAEnabled ? (
      <Navigate replace to={routePaths.verifyTwoFa} />
    ) : (
      <Navigate replace to={routePaths.enableTwoFa} />
    )
  }

  if (!isFullScope(data.scope)) {
    return <Navigate replace to={routePaths.login} />
  }

  const user = data.data
  if (whoCanAccess && intersection(whoCanAccess, user?.role).length === 0) {
    return <Forbidden />
  }

  return <>{component}</>
}

export default ProtectedRoute
